import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8 1.332.428.003.41.012.2.008.386.023.368.03c3.125.304 4.434 1.556 4.778 4.605l.02.193.03.369.028.484.004.1.01.412.004.428-.003.428-.011.41-.01.2-.022.386-.03.368c-.304 3.125-1.556 4.434-4.604 4.778l-.194.02-.368.03-.485.028-.1.004-.412.011-.427.003-.428-.003-.411-.011-.2-.009-.386-.023-.368-.03c-3.125-.304-4.433-1.556-4.777-4.604l-.02-.194-.031-.368-.028-.485-.004-.1-.01-.411-.004-.212v-.432l.003-.212.011-.411.01-.2.022-.385.03-.369c.304-3.125 1.556-4.433 4.604-4.777l.194-.02.369-.031.484-.027.1-.004.412-.012q.21-.003.428-.003m0 6h-.667l-.078.005a.667.667 0 0 0 0 1.324l.078.004v2l.005.078a.67.67 0 0 0 .583.584l.079.005h.666l.078-.005a.67.67 0 0 0 .584-.584l.005-.078-.005-.078a.67.67 0 0 0-.51-.571l-.074-.013-.078-.004v-2l-.005-.078a.67.67 0 0 0-.583-.584zm.006-2-.085.005a.667.667 0 0 0 0 1.324L8 6.665l.084-.004a.667.667 0 0 0 0-1.324z"
    }, null, -1)
  ])))
}
export default { render: render }